<template>
  <div :class="{ 'l-ad--hide-all-amp-units': isHideAd === 'Y' }">
    <HeaderAMP />
    <Nuxt />
    <FooterAMP />
  </div>
</template>

<script>
import HeaderAMP from '@/components/HeaderAMP.vue'
import FooterAMP from '@/components/FooterAMP.vue'

export default {
  components: {
    HeaderAMP,
    FooterAMP
  },
  computed: {
    isHideAd() {
      return this.$store.state.ad.isHideAd
    }
  }
}
</script>

<style lang="scss">
// base
@import '~/assets/scss/base/_amp_reset';
</style>
